export const SET_IS_TESTING_ENV = 'META:SET_IS_TESTING_ENV';
export const SET_IS_DEV_ENV = 'META:SET_IS_DEV_ENV';
export const SET_IS_LOCALHOST_ENV = 'META:SET_IS_LOCALHOST_ENV';
export const SET_IS_EMEX = 'META:SET_IS_EMEX';
export const SET_IS_MOBILE = 'META:SET_IS_MOBILE';
export const SET_IS_BIG_TABLET = 'META:SET_IS_BIG_TABLET';

const actions = {
  setIsMobile: (isMobile) => ({
    type: SET_IS_MOBILE,
    payload: isMobile,
  }),
  setIsBigTabletAndDesktop: (isBigTablet) => ({
    type: SET_IS_BIG_TABLET,
    payload: isBigTablet,
  }),
  setIsTestingEnv:{
    type: SET_IS_TESTING_ENV,
  },
  setIsDevEnv:{
    type: SET_IS_DEV_ENV,
  },
  setIsLocalhostEnv:{
    type: SET_IS_LOCALHOST_ENV,
  },
  setIsEmex:{
    type: SET_IS_EMEX,
  },
};

export default actions;
